export const SET_HRES6AE_INDEX_DISP = 'SET_HRES6AE_INDEX_DISP'
export const GET_HRES6AE_INDEX_DISP = 'GET_HRES6AE_INDEX_DISP'
export const SET_HRES6AE_DETAIL_DISP = 'SET_HRES6AE_DETAIL_DISP'
export const GET_HRES6AE_DETAIL_DISP = 'GET_HRES6AE_DETAIL_DISP'
export const SET_HRES6AE_MAX_ROWSPAN = 'SET_HRES6AE_MAX_ROWSPAN'
export const GET_HRES6AE_MAX_ROWSPAN = 'GET_HRES6AE_MAX_ROWSPAN'
export const SET_HRES6AE_COLUMNS = 'SET_HRES6AE_COLUMNS'
export const GET_HRES6AE_COLUMNS = 'GET_HRES6AE_COLUMNS'
export const SET_HRES6AE_LABELS = 'SET_HRES6AE_LABELS'
export const GET_HRES6AE_LABELS = 'GET_HRES6AE_LABELS'
export const RECEIVED_HRES6AE_COLUMNS_LABELS = 'RECEIVED_HRES6AE_COLUMNS_LABELS'
export const SET_HRES6AE_INDEX = 'SET_HRES6AE_INDEX'
export const GET_HRES6AE_INDEX = 'GET_HRES6AE_INDEX'
export const SET_HRES6AE_INDEX_SELECTED = 'SET_HRES6AE_INDEX_SELECTED'
export const GET_HRES6AE_INDEX_SELECTED = 'GET_HRES6AE_INDEX_SELECTED'
export const RECEIVED_HRES6AE_INDEX = 'RECEIVED_HRES6AE_INDEX'
export const SET_HRES6AE_CURRENT_NUMSEQ = 'SET_HRES6AE_CURRENT_NUMSEQ'
export const GET_HRES6AE_CURRENT_NUMSEQ = 'GET_HRES6AE_CURRENT_NUMSEQ'
export const RECEIVED_HRES6AE_CURRENT_NUMSEQ = 'RECEIVED_HRES6AE_CURRENT_NUMSEQ'
export const SET_HRES6AE_DETAIL = 'SET_HRES6AE_DETAIL'
export const GET_HRES6AE_DETAIL = 'GET_HRES6AE_DETAIL'
export const RECEIVED_HRES6AE_DETAIL = 'RECEIVED_HRES6AE_DETAIL'
export const SET_HRES6AE_DETAIL_SEARCH = 'SET_HRES6AE_DETAIL_SEARCH'
export const GET_HRES6AE_DETAIL_SEARCH = 'GET_HRES6AE_DETAIL_SEARCH'
export const RECEIVED_HRES6AE_DETAIL_SEARCH = 'RECEIVED_HRES6AE_DETAIL_SEARCH'
export const TOGGLE_HRES6AE_PAGE = 'TOGGLE_HRES6AE_PAGE'
export const POST_HRES6AE_SAVE = 'POST_HRES6AE_SAVE'
export const POST_HRES6AE_CANCEL = 'POST_HRES6AE_CANCEL'
export const GET_HRES6AE_SAVE_BUTTON_DISP = 'GET_HRES6AE_SAVE_BUTTON_DISP'
export const SET_HRES6AE_SAVE_BUTTON_DISP = 'SET_HRES6AE_SAVE_BUTTON_DISP'



// WEBPACK FOOTER //
// ./src/store/modules/hres6ae/mutation-types.js